import classnames from 'classnames';
import Flex from './Flex.css';
import Pane from './Pane.css';
import Popup from './Popup.css';
import Label from './Label.css';
import Button from './Button.css';
import Toggle from './Toggle.css';
import TabPane from './TabPane.css';
import Checkbox from './Checkbox.css';
import CheckboxProps from './CheckboxProps.js';
import SplitPane from './SplitPane.css';
import TextInput from './TextInput.css';
import ToggleButton from './ToggleButton.css';
const styles = {
  Button,
  ToggleButton,
  TextInput,
  Flex,
  Pane,
  Popup,
  Label,
  TabPane,
  Checkbox,
  SplitPane,
  Toggle
};
const props = {
  Checkbox: CheckboxProps
};
const EMPTY = {};
export default class DefaultTheme {
  /**
   * Returns the classnames needed for the component's type and variant. 
   * @param {string} component the name of the component type. eg "Button"
   * @param {string} type the part of the component to get. eg "button"
   * @param {string} variant the variant name to requsest. eg "small"
   * @param {strings} rest other strings to add to the classname
   * @return {string} the classname
   **/
  classes(component, type, variant, ...rest) {
    if (styles[component]) {
      variant = variant == null ? null : styles[component][`${type}-${variant}`];
      const c = classnames(styles[component][type], variant, ...rest);
      return c;
    }
    return classnames(...rest);
  }

  /**
   * Returns the classnames needed for the component's sub element. The variant
   * is not needed here because it will be in the css rule as a parent. 
   * @param {string} component the name of the component type. eg "Button"
   * @param {string} type the sub-component of the component to get. eg "button"
   * @param {strings} rest other strings to add to the classname
   * @return {string} the classname
   **/
  subclasses(component, type, ...rest) {
    if (styles[component]) {
      return classnames(styles[component][type], ...rest);
    }
    return classnames(...rest);
  }

  /**
   * Returns any default props for the supplied Component and Variant.
   * If the third argument is an object, it will be overlaid on top of
   * the component's default props and the component's variant props.
   *
   * If the second argument is an object, it is considered to be the
   * React component's actual props object, and the variant is looked
   * up from it. This means from render, you can invoke:
   *   const { markClass } = theme.props( 'Checkbox', this.props )
   * @param {string} component the name of the component type. eg "Button"
   * @param {string|object} variant the variant name to requsest. eg "small"
   * @return {object} an object containing the default props. This will be a 
   * merger of the default variant's props and the specified variants props. 
   * This will always return an object
   **/
  props(component, variant, userProps = EMPTY) {
    if (variant != null && typeof variant === 'object') {
      return this.props(component, variant.variant, variant);
    }
    if (props[component]) {
      const d = props[component].default || EMPTY;
      const v = variant && props[component][variant] || EMPTY;
      return {
        ...d,
        ...v,
        ...userProps
      };
    }
    return userProps === EMPTY ? {} : userProps;
  }
}